import { NgModule } from '@angular/core';
import { StudentModule } from '@coach-bot/features/student';
import { ButtonsModule, ChipModule } from '@progress/kendo-angular-buttons';
import { LoaderModule } from '@progress/kendo-angular-indicators';
import { ProgressBarModule } from '@progress/kendo-angular-progressbar';
import { SharedUIModule } from '@shared/ui';
import { DashboardComponent, EmptyComponent, InactiveComponent } from './components';

const COMPONENTS = [DashboardComponent, EmptyComponent, InactiveComponent];

@NgModule({
  imports: [
    ButtonsModule,
    LoaderModule,
    ChipModule,
    ProgressBarModule,
    StudentModule,
    SharedUIModule
  ],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class DashboardModule {}
